export default __webpack_public_path__ + "static/media/game_3_r.a0555963.png";